import { InformationRequest, InformationResponse } from "domain/entity/Information";
import InformationRepository from "domain/repository/Information";

export default class InformationUseCase {
    constructor(private service: InformationRepository) { }

    getInformation({...rest}: InformationRequest): Promise<InformationResponse> {
        return this.service.getInformation({...rest})
    }
}